import { Link } from "react-router-dom";
import { container, SECTORS } from "@/lib/constants";

export function Footer() {
  return (
    <footer className="border-t border-border mt-24 bg-[hsl(var(--pdg-charcoal))]">
      <div className={`${container} py-16`}>
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="pdg-serif text-lg tracking-[0.12em] text-foreground">PRIME DEAL GATEWAY</div>
            <p className="mt-4 text-sm text-muted-foreground leading-7 max-w-xs">
              A by-invitation acquisition desk for verified principals. Discreet access to
              off-market European opportunities.
            </p>
          </div>
          <div>
            <div className="pdg-kicker">Navigate</div>
            <ul className="mt-4 space-y-2 text-sm text-foreground/75">
              <li><Link to="/about" className="hover:text-foreground">About</Link></li>
              <li><Link to="/process" className="hover:text-foreground">Process</Link></li>
              <li><Link to="/membership" className="hover:text-foreground">Membership</Link></li>
              <li><Link to="/how-to-use" className="hover:text-foreground">How to use</Link></li>
              <li><Link to="/orla" className="hover:text-foreground">ORLA</Link></li>
            </ul>
          </div>
          <div>
            <div className="pdg-kicker">Sectors</div>
            <ul className="mt-4 space-y-2 text-sm text-foreground/75">
              {Object.entries(SECTORS).map(([k, v]) => (
                <li key={k}><Link to="/sectors" className="hover:text-foreground">{v}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="pdg-kicker">Legal</div>
            <ul className="mt-4 space-y-2 text-sm text-foreground/75">
              <li><Link to="/legal/terms" className="hover:text-foreground">Terms</Link></li>
              <li><Link to="/legal/privacy" className="hover:text-foreground">Privacy</Link></li>
              <li><Link to="/legal/cookies" className="hover:text-foreground">Cookies</Link></li>
              <li><Link to="/legal/risk" className="hover:text-foreground">Risk Disclosure</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground max-w-2xl leading-6">
            &copy; {new Date().getFullYear()} Prime Deal Gateway. For professional and institutional counterparties only.
            Nothing on this site constitutes an offer, solicitation, or investment advice. Jurisdictions: UK, EU, UAE, Singapore, US.
          </p>
          <span className="pdg-kicker">By invitation only</span>
        </div>
      </div>
    </footer>
  );
}
